//Library modul
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

//Personal Component
import Modal from "../common_modal/Modal";

//Redux function
import { edit_properties_upload } from "../../App/actions/layerActions";

//Picture Asset
import icon_upload from "../../Assets/svg/icon_upload.svg";

//General Function
import uuid from "../../App/validation/uuid";
import { getGeoLayer } from "../../App/reduxHelper/layer";
import dict from "../../Data/dict.json";

// const language = localStorage?.language ? localStorage?.language : "ina";

const Image = ({ params, layer_id, language, set_textfield }) => {
  const [modalImagePreview, setModalImagePreview] = useState(false);
  const [image, setImage] = useState("");

  const dispatch = useDispatch();
  const layer = useSelector((state) => state.layer);
  const fileInput = useRef(null);

  useEffect(() => {
    setImage(params?.value || "");
  }, [params?.value]);

  const toggleImagePreview = () => {
    setModalImagePreview((prev) => !prev);
  };

  const handlePreviewImage = (previewParams) => {
    setImage(previewParams.value);
  };

  const set_image = (value) => {
    setImage(value);
  };

  const handle_submit = async (e) => {
    e.preventDefault();
    const file = fileInput.current.files[0];

    if (!file) return;

    const body_file = {
      file: file,
      file_name: `img_%${file?.name}_%${uuid()}`,
      dirname: "properties",
    };

    const feature_key = params?.row?.key;
    const properties_key = params?.field;
    const upload_params = params?.row?.nested_attributes ? params : undefined;

    const body_database = {
      geo_layer_id: layer_id,
      feature_key: feature_key,
      properties_key: properties_key,
      properties_value: "", //boleh dikosongkan karena akan ditimpa dengan url dengan methode edit_properties_image
    };

    let body = {
      body_file,
      body_database,
      mode: "image",
    };

    const result = await dispatch(
      edit_properties_upload(
        body,
        getGeoLayer(layer)?.architecture,
        layer_id,
        upload_params,
      ),
    );

    if (set_textfield) {
      set_textfield(result?.properties_value, properties_key);
    } else {
      set_image(result?.properties_value);
    }
  };

  const fileNameOnServer = image?.split("/")?.at(-1);
  const arrayName = fileNameOnServer?.split("_%25");
  const originalName =
    arrayName?.at(0)?.split("_")?.at(1) === "img"
      ? arrayName?.at(1)?.replaceAll("%20", " ")
      : "";

  return (
    <section
      style={{
        height: "100%",
        width: "100%",
        padding: 5,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <label className="fileContainer">
        <div
          className="hover_darkGreen hover_bigger"
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "10px",
            width: 15,
            height: 15,
            backgroundColor: "#e6eef3",
            padding: "5px",
            border: "1px solid #9ca8bb",
            borderRadius: "99px",
          }}
        >
          <img
            src={icon_upload}
            className="h_15 w_15 rounded"
            alt="upload system"
          />
          {/* {dict["Upload image"][language]} */}
        </div>
        <input
          id={`${params?.row?.key}-${params?.field}`}
          style={{ display: "none" }}
          type="file"
          accept="image/*"
          ref={fileInput}
          onChange={handle_submit}
        />
      </label>

      {image ? (
        <div className="flex gap_5 h_2">
          <div title={originalName} className="w_150 center_perfect">
            <p className="truncate">{originalName}</p>
          </div>
          <div
            onClick={() => {
              if (params?.value) {
                handlePreviewImage(params);
                toggleImagePreview();
              }
            }}
            style={{ cursor: "pointer", display: "inline" }}
          >
            <img
              src={image}
              style={{
                width: 35,
                height: 35,
                objectFit: "cover",
              }}
              alt=""
            />
          </div>
        </div>
      ) : (
        <div
          style={{
            fontSize: "10px",
            width: 80,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {dict["No image"][language]}
        </div>
      )}

      {modalImagePreview && (
        <Modal
          modalSize="large"
          id="modal"
          isOpen={modalImagePreview}
          onClose={toggleImagePreview}
        >
          <div
            className="box-body"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={image}
              alt="modal"
              style={{
                maxWidth: "80vw",
                maxHeight: "80vh",
                objectFit: "contain",
              }}
            />
          </div>
        </Modal>
      )}
    </section>
  );
};

export default Image;
